<template>
    <div :class="this.errorOverlayClass"></div>
</template>

<script>
export default {
  props: [
    'value',
  ],  
  data () {
    return {
        errorOverlayClass: '',
    }
  },
  watch: {
    value: {
        immediate: true,
        handler(value) {
            if (undefined === value) {
                return
            }
            
            //this.errorOverlayClass = { 'error-overlay': true, 'is-active': (0 !== Object.entries(value).length) }

            if (0 !== Object.entries(value).length) {
              this.errorOverlayClass = { 'error-overlay': true, 'is-active': true }

              setTimeout(function() {
                this.errorOverlayClass = { 'error-overlay': true, 'is-active': false } // after 100 ms transition effects starts
              }.bind(this), 100);
              
              setTimeout(function() {
                this.errorOverlayClass = { 'error-overlay': false, 'is-active': false } // set error-overlay to false (after transition effect), otherwise the scrollbars not working
              }.bind(this), 600);
            } 
        },
    },
  },
  computed: {
  },
  created() {
  },
  methods: {
  },
}
</script>

<style>
.error-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    background-color: rgba(255,0,0,0);
    z-index: -9999;
	transition: background-color 500ms ease-in-out, z-index 500ms steps(1,jump-end);
}
.error-overlay.is-active {
    background-color: rgba(255,0,0,0.7);
    transition: background-color,z-index 0s;
    z-index: 9999;
}
</style>

